import { RootStore } from '../rootStore';
import { ADMIN_INSTRUMENTS } from 'api/endpoints';
import { observable, action } from 'mobx';

export interface Instrument {
  code: string;
  title: string;
  isin: string;
  locked: boolean;
  enabled: boolean;
}

interface InstrumentsData {
  assets: Instrument[];
  intermediaryCode: string;
}

export class AdminInstrumentsStore {
  rootStore: RootStore;
  data: InstrumentsData | null = null;
  @observable list: Instrument[] = [];
  @observable editing = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action
  fetchList = async (intermediary: string) => {
    const { uiStore, apiStore } = this.rootStore.stores;
    uiStore.setLoading(true);
    const response = await apiStore.get<InstrumentsData>(ADMIN_INSTRUMENTS(intermediary));
    if (response?.data) {
      this.data = response.data;
      this.convertList(response.data.assets);
    }
    uiStore.setLoading(false);
  };

  @action
  convertList = (data: Instrument[]) => {
    this.list = data.map((i) => ({ id: i.code, ...i }));
  };

  @action
  restoreOriginal = () => {
    this.convertList(this.data!.assets);
    this.editing = false;
  };

  @action
  setInstrument = (code: string, enabled: boolean) => {
    this.editing = true;
    this.list[this.list.findIndex((i) => i.code === code)].enabled = enabled;
    this.list = this.list.slice();
  };

  @action
  save = async () => {
    const { uiStore, apiStore } = this.rootStore.stores;
    uiStore.setLoading(true);
    const response = await apiStore.post(ADMIN_INSTRUMENTS(this.data!.intermediaryCode), {
      assets: this.list,
    });
    uiStore.setLoading(false);
    if (!!response?.data) this.editing = false;
  };
}
